import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Montserrat', 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      main: '#707072',
    },
    secondary: {
      main: '#03DAC6',
    },
    textPrimary: {
      main: 'rgba(0, 0, 0, 0.87)',
    },
    textSecondary: {
      main: 'rgba(0, 0, 0, 0.57)',
    },
    activeBg: {
      main: '#d8d8d8',
    },
    error: {
      main: '#b00020',
    },
    border: {
      main: '#0000001a',
    },
  },
});

export default theme;
